// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1q1K4","noInteraction":"EventWrapper_noInteraction__1J9gT","pointerPassthrough":"EventWrapper_pointerPassthrough__1pU3o"};